import { Pressable, PressableProps, StyleSheet, View } from 'react-native';

import { ImageWithBlurhash } from '%components/ImageWithBlurhash';
import { PlayIcon } from './PlayIcon';
import { MediaVideoProps } from '..';

type Props = Pick<MediaVideoProps, 'source' | 'style'> & Pick<PressableProps, 'onPress'>;

export const VideoThumbnail = ({ source, style, onPress }: Props) => {
	if (!source.thumbnailUrl) {
		return null;
	}

	const thumbnailSource = {
		headers: source.headers,
		uri: source.thumbnailUrl,
		blurhash: source.thumbnailBlurhash,
	} as const;

	const IconContainer = onPress ? Pressable : View;

	return (
		<View style={[style, styles.thumbnailContainer]} testID="video-thumbnail">
			<ImageWithBlurhash source={thumbnailSource} style={style} />

			<IconContainer style={styles.playIcon} onPress={onPress} testID="video-thumbnail-play">
				<PlayIcon />
			</IconContainer>
		</View>
	);
};

const styles = StyleSheet.create({
	thumbnailContainer: { alignItems: 'center', justifyContent: 'center' },
	playIcon: {
		position: 'absolute',
		marginHorizontal: 'auto',
	},
});
